export default __webpack_public_path__ + "static/media/removebg.6626e9ac.webp";